import { fieldState } from './state';

// --- FUNKCJE DO OBSŁUGI BŁĘDÓW INLINE ---

export function showInlineError(inputId: string, message: string): void {
  if (!fieldState[inputId]?.touched) return;
  const input = document.getElementById(inputId);
  const errorElement = document.querySelector<HTMLElement>(`.error-message[data-for="${inputId}"]`);
  if (input && errorElement) {
    errorElement.textContent = message;
    errorElement.classList.add('visible');
    input.classList.add('has-error');
  }
}

export function clearInlineError(inputId: string): void {
  const input = document.getElementById(inputId);
  const errorElement = document.querySelector<HTMLElement>(`.error-message[data-for="${inputId}"]`);
  if (input && errorElement) {
    errorElement.classList.remove('visible');
    input.classList.remove('has-error');
  }
}
